const NO_COVERAGE_SELECTED = 'no coverage selected'
// TEMP: Association Virtual Care is excluded from all flex benefits surfaces
// (display, modal, and price calculation) per business decision.
// Remove once the benefit is officially deprecated from the FlexBenefits API.
const VIRTUAL_CARE_AMOUNT = 'Virtual Care'

export function isVirtualCareBenefit(benefit: any): boolean {
  return (benefit?.levels || []).some(
    (level: any) => String(level.amount ?? '').trim() === VIRTUAL_CARE_AMOUNT
  )
}

function hasNoCoverageSelectedText(value = '') {
  return String(value).toLowerCase().includes(NO_COVERAGE_SELECTED)
}

function isNotSelectedLevel(level = {}) {
  const amount = String(level.amount ?? '').trim()
  return amount === '0' || amount === '0.00'
}

export function getSelectedLevel(
  benefit: any,
  levelSelections: Record<string, string> = {}
) {
  const overrideLevelId = levelSelections[benefit?.id]
  const levels: any[] = benefit?.levels || []
  return overrideLevelId
    ? levels.find(l => l.id === overrideLevelId) ?? levels.find(l => l.isSelected)
    : levels.find(l => l.isSelected)
}

export function getExternalPlanTotal(
  plan: any,
  levelSelections: Record<string, string> = {}
): number {
  if (!plan) return 0
  return plan.products
    .flatMap((p: any) => p.benefits || [])
    .filter((benefit: any) => !isVirtualCareBenefit(benefit))
    .reduce(
      (sum: number, benefit: any) =>
        sum + (getSelectedLevel(benefit, levelSelections)?.price || 0),
      0
    )
}

interface ParseBenefitsOptions {
  suppressNoCoverageSelected?: boolean
  selectedLevels?: Record<string, string>
}

export const parseBenefits = (products = [], options: ParseBenefitsOptions = {}) => {
  const { suppressNoCoverageSelected = false, selectedLevels } = options

  return products
    .flatMap(product => product?.benefits || [])
    .filter(benefit => !isVirtualCareBenefit(benefit))
    .map(benefit => {
      const selected = getSelectedLevel(benefit, selectedLevels)
      if (!selected) return null

      if (suppressNoCoverageSelected) {
        const value = String(selected.description || '').trim()
        if (!value) return null
        if (isNotSelectedLevel(selected)) return null
        if (hasNoCoverageSelectedText(value)) return null
        if (hasNoCoverageSelectedText(benefit?.name)) return null
      }

      return { label: benefit.name, value: selected.description }
    })
    .filter(Boolean)
}

export function getSuppressedBenefitsCount(
  products: any[] = [],
  selectedLevels: Record<string, string> = {}
): number {
  return products
    .flatMap((product: any) => product?.benefits || [])
    .filter((benefit: any) => !isVirtualCareBenefit(benefit))
    .filter(benefit => {
      const selected = getSelectedLevel(benefit, selectedLevels)
      if (!selected) return false
      const value = String(selected.description || '').trim()
      return (
        !value ||
        isNotSelectedLevel(selected) ||
        hasNoCoverageSelectedText(value) ||
        hasNoCoverageSelectedText(benefit?.name)
      )
    }).length
}
